import React, { Component, createRef } from 'react';
import { bool, node, oneOf } from 'prop-types';
import classnames from 'classnames/bind';

import Popover from 'react-awesome-popover';
import Icon from 'foundations/Icons/Icon';

import styles from './Tooltip.css';

class Tooltip extends Component {
  static propTypes = {
    placement: oneOf([
      'top',
      'right',
      'bottom',
      'left',
      'top-start',
      'right-start',
      'bottom-start',
      'left-start',
      'top-end',
      'right-end',
      'bottom-end',
      'left-end',
    ]),
    children: node.isRequired,
    target: node.isRequired,
    click: bool,
    purpleBackground: bool,
    open: bool,
    whiteBackground: bool,
    withCloseButton: bool
  }

  static defaultProps = {
    open: undefined,
    placement: 'top'
  }

  wrapperRef = createRef();
  hasOpenProp = this.props.open !== undefined;

  state = {
    isOpen: false
  }

  static getDerivedStateFromProps (nextProps) {
    if (nextProps.open !== undefined) {
      return {
        isOpen: nextProps.open
      };
    }

    return null;
  }

  getTipOffset = () => {
    let { placement } = this.props;
    let middleOfTarget = null;

    placement = placement.split('-');

    if (placement[1]) {
      const wrapperBounds = this.wrapperRef.current.getBoundingClientRect();
      const isColumnDirection = placement[0] === 'top' || placement[0] === 'bottom';

      if (isColumnDirection) {
        middleOfTarget = wrapperBounds.width / 2;
      } else {
        middleOfTarget = wrapperBounds.height / 2;
      }

      const offset = isColumnDirection ? 39 : 34;
      const operator = placement[1] === 'start' ? 1 : -1;
      
      return (middleOfTarget - offset) * operator;
    }

    return 0;
  }

  toggleTooltip = () => !this.hasOpenProp && this.setState({ isOpen: !this.state.isOpen });

  handleMouseEnter = () => !this.hasOpenProp && this.setState({ isOpen: true });

  handleMouseLeave = () => !this.hasOpenProp && this.setState({ isOpen: false });

  renderCloseButton = () => (
    <a className={styles.closeButton} onClick={this.toggleTooltip}>
      <Icon icon={'close'} type={'15'} />
    </a>
  );

  render () {
    const { isOpen } = this.state;
    const {
      placement,
      children,
      target,
      click,
      purpleBackground,
      whiteBackground,
      withCloseButton,
      open
    } = this.props;
    const wrapperProps = click
      ? 
        {
          onClick: this.toggleTooltip
        }
      : 
        {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }
    ;
    const cx = classnames.bind(styles);
    const backgroundsColors = {
      purple: purpleBackground,
      white: whiteBackground
    };
    const PopoverModifiers = {
      offset: {
        enabled: true,
        offset: `${this.getTipOffset()}px, 5px`
      },
      preventOverflow: {
        escapeWithReference: true
      }
    };
    const innerBlockProps = !click && wrapperProps;

    return (
      <Popover
        arrow
        action={null}
        arrowClass={cx('arrow', backgroundsColors)}
        contentClass={cx('tooltip', backgroundsColors, { 'defaultOpen': open })}
        defaultIsOpen={null}
        modifiers={PopoverModifiers}
        onClosePopover={this.toggleTooltip}
        open={isOpen}
        placement={placement}
      >
        <div ref={this.wrapperRef} {...wrapperProps}>
          {target}
        </div>  
        <div className={styles.innerBlock} {...innerBlockProps}>
          {withCloseButton && this.renderCloseButton()}
          {children}
        </div>
      </Popover>
    );
  }
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/uis/elements/Tooltip/Tooltip.js